import FocusOnElement from "./focusOnElement";
import './_c-focusedElement.scss';

nn.registerModule('focusOnElement', function (element, config) {
  return new FocusOnElement(element, config);
});